<template>
    <div class="w-full">
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Sizes:
        </div>
        <div class="flex items-center gap-4 mb-5 flex-wrap">
            <div
                v-for="item in sizes"
                :key="item"
                class="flex items-center gap-4"
            >
                <RedesignBaseButton
                    :label="`Button ${item}`"
                    :size="item"
                    icon="PlusSquare"
                />
                <RedesignBaseButton
                    :label="`Button ${item}`"
                    :size="item"
                />
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Colors:
        </div>
        <div class="flex items-center gap-4 mb-5">
            <div
                v-for="item in colors"
                :key="item"
                class="flex items-center gap-4"
            >
                <RedesignBaseButton
                    :label="`Button ${item}`"
                    :color="item"
                    icon="PlusSquare"
                />
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Types:
        </div>
        <div class="flex flex-col gap-4 mb-5">
            <div
                v-for="type in types"
                :key="type"
                class="flex items-center gap-4 flex-wrap"
            >
                <RedesignBaseButton
                    v-for="color in colors"
                    :key="`${type}-${color}`"
                    :label="`Button ${type} ${color}`"
                    :color="color"
                    :type="type"
                    icon="PlusSquare"
                />
            </div>
            <div>
                <RedesignBaseButton
                    label="Button Block"
                    color="primary"
                    icon="PlusSquare"
                    block
                />
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Disabled:
        </div>
        <div class="flex flex-col gap-4 mb-5">
            <div
                v-for="type in types"
                :key="type"
                class="flex items-center gap-4 flex-wrap"
            >
                <RedesignBaseButton
                    v-for="color in colors"
                    :key="`${type}-${color}`"
                    :label="`Button ${type} ${color}`"
                    :color="color"
                    :type="type"
                    icon="PlusSquare"
                    disabled
                />
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Loader:
        </div>
        <div class="flex flex-col gap-4 mb-5">
            <div
                v-for="type in types"
                :key="type"
                class="flex items-center gap-4 flex-wrap"
            >
                <RedesignBaseButton
                    v-for="color in colors"
                    :key="`${type}-${color}`"
                    :label="`Button ${type} ${color}`"
                    :color="color"
                    :type="type"
                    icon="PlusSquare"
                    loading
                />
            </div>
            <div class="flex">
                <RedesignBaseButton
                    label="Button Block"
                    color="primary"
                    icon="PlusSquare"
                    block
                    loading
                />
            </div>
        </div>
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Icon Button:
        </div>
        <div class="flex gap-4 items-center mb-5">
            <RedesignBaseIconButton
                v-for="iconBtn in icons"
                :key="`base-${iconBtn}`"
                :icon="iconBtn"
                @click="onClick"
            />
            <RedesignBaseIconButton
                v-for="iconBtn in icons"
                :key="`primary-${iconBtn}`"
                :icon="iconBtn"
                color="primary"
                @click="onClick"
            />
            <RedesignBaseIconButton
                v-for="iconBtn in icons"
                :key="`destructive-${iconBtn}`"
                :icon="iconBtn"
                color="destructive"
                @click="onClick"
            />
            <RedesignBaseIconButton
                icon="Trash2"
                color="destructive"
                disabled
                @click="onClick"
            />
            <RedesignBaseIconButton
                :size="16"
                icon="Pencil"
                @click="onClick"
            />
            <RedesignBaseIconButton
                :size="32"
                icon="Pencil"
                @click="onClick"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import { TButtonColor, TButtonSize, TButtonType } from '@/components/RedesignBaseComponents/Buttons/buttons'
import RedesignBaseIconButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseIconButton.vue'

const sizes: Array<TButtonSize> = [ 'mini', 'small', 'middle', 'large' ]
const colors: Array<TButtonColor> = [ 'primary', 'secondary', 'destructive' ]
const types: Array<TButtonType> = [ 'default', 'outline', 'soft', 'text' ]

const icons = [
    'Pencil',
    'ClipboardCopy',
    'Plus',
    'PlusCircle',
    'MoreVertical',
    'Trash2'
]

function onClick () {
    alert('Click Event!')
}
</script>

